import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 18 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5666 0.295447L15.704 2.43049V2.42889C15.7977 2.5223 15.872 2.63327 15.9227 2.75543C15.9734 2.8776 15.9995 3.00857 15.9995 3.14084C15.9995 3.27311 15.9734 3.40408 15.9227 3.52625C15.872 3.64842 15.7977 3.75938 15.704 3.85279L14.6361 4.92071C14.5412 5.01422 14.4134 5.06663 14.2801 5.06663C14.1469 5.06663 14.0191 5.01422 13.9242 4.92071L11.0772 2.07372C10.9837 1.97883 10.9312 1.85096 10.9312 1.71774C10.9312 1.58453 10.9837 1.45666 11.0772 1.36177L12.1427 0.295447C12.2361 0.201795 12.3471 0.127492 12.4692 0.0767942C12.5914 0.0260964 12.7224 0 12.8546 0C12.9869 0 13.1179 0.0260964 13.2401 0.0767942C13.3622 0.127492 13.4732 0.201795 13.5666 0.295447Z",
			fill: "#545F7E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.90982e-05 15.4928V12.8225C0.000752529 12.5561 0.106207 12.3007 0.293658 12.1114L8.89624 3.50802C8.99072 3.41714 9.11672 3.36638 9.24781 3.36638C9.37891 3.36638 9.50491 3.41714 9.59939 3.50802L12.456 6.35501C12.5495 6.4499 12.6019 6.57777 12.6019 6.71099C12.6019 6.84421 12.5495 6.97207 12.456 7.06696L3.8886 15.7063C3.6991 15.894 3.44333 15.9995 3.17665 15.9999H0.507243C0.440313 16.0011 0.373828 15.9888 0.311758 15.9637C0.249687 15.9387 0.193302 15.9014 0.145967 15.854C0.0986333 15.8067 0.0613202 15.7503 0.0362551 15.6882C0.0111899 15.6262 -0.00111346 15.5597 7.90982e-05 15.4928Z",
			fill: "#545F7E"
		})
	]
});
const ForwardRef = forwardRef(SvgEdit);
export default ForwardRef;
